module.exports = __webpack_public_path__ + "fonts/Gilroy-Bold.889a4b5c.ttf";